module.exports = __webpack_public_path__ + "static/media/insta.d8b84367.svg";